import React from "react";
import EditorMain from "./EditorMain";
import addQueryInputNode from "./services/addQueryInputNode";
import { PlainDocumentContext } from "./services/editorSurface";
import { shallowEqual, useSelector } from "react-redux";

interface FpEditorProps {
  editorContent: string | null;
  // A Document (Artifacts surface / chat panel) is plain text: no inline
  // Ask-Finpilot machinery (#11548 round 16). Defaults to the full report
  // editor.
  plainDocument?: boolean;
  isLeftBarOpen: boolean;
  setIsLeftBarOpen: (open: boolean) => void;
  hideLeftSidebar?: boolean;
  showTableOfContents?: boolean;
  setShowTableOfContents?: (show: boolean) => void;
  // A snapshot shown for reading only (#11835: a past version in the
  // history view) — same page styling as the live document, never
  // editable, never autosaved.
  readOnly?: boolean;
  // Inside a pane that is itself the floating card (#12481): the document
  // sits on the host's surface, with no page ground and no sheet of its own.
  flatGround?: boolean;
}

const FpEditor = ({
  editorContent,
  plainDocument = false,
  isLeftBarOpen,
  setIsLeftBarOpen,
  hideLeftSidebar = false,
  showTableOfContents = false,
  setShowTableOfContents,
  readOnly = false,
  flatGround = false,
}: FpEditorProps) => {
  const editorDisabled = useSelector(
    (state: any) => state.fpAppV4Data.editorDisabled,
    shallowEqual
  );
  return (
    <PlainDocumentContext.Provider value={plainDocument}>
      <div
        className="h-full w-full relative"
        style={{
          pointerEvents: editorDisabled ? "none" : "auto",
          opacity: editorDisabled ? 0.5 : 1,
        }}
      >
        <div
          className="h-full w-full overflow-auto"
          onKeyDown={(e) => {
            if (editorDisabled) {
              e.stopPropagation();
              e.preventDefault();
              return;
            }
            if (e.key === "/" && !plainDocument) {
              addQueryInputNode(e);
            }
          }}
        >
          <EditorMain
            editorContent={editorContent || null}
            isLeftBarOpen={isLeftBarOpen}
            setIsLeftBarOpen={setIsLeftBarOpen}
            hideLeftSidebar={hideLeftSidebar}
            showTableOfContents={showTableOfContents}
            setShowTableOfContents={setShowTableOfContents}
            readOnly={readOnly}
            flatGround={flatGround}
          />
        </div>
      </div>
    </PlainDocumentContext.Provider>
  );
};

export default FpEditor;
